module.exports = __webpack_public_path__ + "static/pic01-79d061f7b953fa65736fedfc203287c5.jpg";